module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-numcard-row"],
    style: {
      backgroundColor: this._backgroundColor
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-4a1de980!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-numcard-row/index.vue
// module id = 607
// module chunks = 0 1